import { AxnTransactionType, AxnSelectedServiceOfferingSO, AxnAttributeType } from "@idw-types/data/reference-data/axn";
import { FormattedVerificationTransactionDetailsTransactionEvent, VerificationTransactionDetailsTransactionEvent } from "@idw-types/data/verification-transaction-details";

export const formatVerificationTransactionDetailsTransactionEvents = (
    transactionEvents: Array<VerificationTransactionDetailsTransactionEvent>,
    transactionTypes: Array<AxnTransactionType>,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>,
    attributeTypes: Array<AxnAttributeType>
): Array<FormattedVerificationTransactionDetailsTransactionEvent> => {
    return transactionEvents.map(transactionEvent => formatVerificationTransactionDetailsTransactionEvent(
        transactionEvent,
        transactionTypes,
        axnSelectedServiceOfferingSOs,
        attributeTypes
    ));
};

export const formatVerificationTransactionDetailsTransactionEvent = (
    transactionEvent: VerificationTransactionDetailsTransactionEvent,
    transactionTypes: Array<AxnTransactionType>,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>,
    attributeTypes: Array<AxnAttributeType>
): FormattedVerificationTransactionDetailsTransactionEvent => {
    let date = null;
    if (transactionEvent.date) {
        date = new Date(parseInt(transactionEvent.date));
    }

    const transactionType = transactionTypes.find(tt => tt.id === transactionEvent.transactionTypeID);

    let details: { [key: string]: any } = {};
    if (transactionEvent.details && typeof transactionEvent.details === "string" && transactionEvent.details !== "null") {
        details = formatTransactionEventDetails(transactionEvent.details, axnSelectedServiceOfferingSOs, attributeTypes)
    }

    return {
        apiKey: transactionEvent.apiKey,
        date: date,
        id: transactionEvent.id,
        details: details,
        referrer: transactionEvent.referrer,
        rpServiceName: transactionEvent.rpServiceName,
        transactionType: transactionType
    };
};

const formatTransactionEventDetails = (
    details: string,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>,
    attributeTypes: Array<AxnAttributeType>
) => {
    const finalDetails: { [key: string]: string } = {};
    try {
        const detailsJSON = JSON.parse(details);
        Object.keys(detailsJSON).forEach((key: string) => {
            if (key === "serviceOfferingID") {
                const serviceOffering = axnSelectedServiceOfferingSOs.find(so => so.id === detailsJSON[key]);
                if (serviceOffering) {
                    finalDetails["Attribute Provider"] = serviceOffering.name;
                }
            } else if (key === "idpType") {
                finalDetails["Identity Provider"] = detailsJSON[key];
            } else if (key === "attributeTypeID") {
                const attributeType = attributeTypes.find(at => at.id === detailsJSON[key]);
                if (attributeType) {
                    finalDetails["Attribute Type"] = attributeType.name;
                }
            } else if (key === "processingTime") {
                finalDetails["Processing Time"] = detailsJSON[key];
            // } else if (key === "delivery" && typeof detailsJSON[key] === "object" && detailsJSON[key] !== null) {
            //     Object.keys(detailsJSON[key]).map(deliveryKey => {
            //         if (typeof deliveryKey === "string") {
            //             finalDetails[deliveryKey] = detailsJSON[key][deliveryKey];
            //         } else if (typeof deliveryKey === "number") {
            //             finalDetails[deliveryKey] = `${detailsJSON[key][deliveryKey]}`;
            //         }
            //     });
            // } else if (key === "mail" && typeof detailsJSON[key] === "object" && detailsJSON[key] !== null) {
            //     Object.keys(detailsJSON[key]).map(mailKey => {
            //         if (typeof mailKey === "string") {
            //             finalDetails[mailKey] = detailsJSON[key][mailKey];
            //         } else if (typeof mailKey === "number") {
            //             finalDetails[mailKey] = `${detailsJSON[key][mailKey]}`;
            //         }
            //     });
            } else if (typeof detailsJSON[key] === "string") {
                finalDetails[key] = detailsJSON[key];
            } else if (typeof detailsJSON[key] === "number" || typeof detailsJSON[key] === "boolean") {
                finalDetails[key] = `${detailsJSON[key]}`;
            }
        });
    } catch (error) {
        console.error("Error parsing transaction event details JSON: ", error);
    }
    return finalDetails;
};